import { render, staticRenderFns } from "./QuestionSingled.vue?vue&type=template&id=056d3004&"
import script from "./QuestionSingled.vue?vue&type=script&lang=js&"
export * from "./QuestionSingled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports